import {createMultiPathSVG} from './TEMPLATE'

// phosphor: sign-in
export const ArrowBoxRight_Stroke2_Corner3_Rounded = createMultiPathSVG({
  paths: [
    'M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM200,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h64a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32Z',
  ],
  viewBox: '0 0 256 256',
})
